/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './suplement-hash-anchors/supplement-hash-anchors.module';
export * from './suplement-hash-anchors/supplement-hash-anchors.pipe';
